import React from 'react';

import { TextArrayProps } from './editorial-page-full-width';
import { RichText } from '@/components/rich-text/rich-text';

export interface FullWidthTextBlockProps {
  body?: any;
  textItem?: TextArrayProps;
  cardType?: string;
  isImage?: boolean;
}

const EditorialPageFullWidthTextWrapper = ({
  body,
  textItem,
  cardType,
  isImage,
}: FullWidthTextBlockProps) => {
  const headingCss =
    'text-text-default font-title mb-4 ' +
    (cardType === 'Carousel item'
      ? 'text-headingm'
      : 'text-headingl sm:text-headingxl');

  const preambleCss =
    'text-text-default font-title mb-4 ' +
    (cardType === 'Carousel item'
      ? 'text-headingm'
      : cardType !== 'Carousel item' && textItem && textItem.title
        ? 'text-headings sm:text-headingm'
        : 'text-headingl sm:text-headingl');

  const columnCss =
    'rounded-card-mobile px-6 sm:px-12 ' +
    (textItem?.topItem && !isImage ? 'pt-0 ' : ' ');

  if (!body && !textItem?.preamble && !textItem?.title) return <></>;

  return (
    <div
      className={
        'h-full w-full flex-col overflow-auto  break-words rounded-card-mobile bg-background-primary-light py-6 sm:py-12  ' +
        (cardType === 'Carousel item'
          ? 'rounded-b-card-mobile px-6 sm:px-12 '
          : cardType === 'Column item'
            ? columnCss
            : cardType === 'Default'
              ? 'px-6 sm:px-12 '
              : cardType === undefined
                ? 'sm:px-12 '
                : ' ')
      }
    >
      {/*Title checks*/}
      {textItem?.title && textItem?.topItem ? (
        <h1 className={headingCss}>{textItem?.title}</h1>
      ) : textItem?.title && !textItem?.topItem ? (
        <h2 className={preambleCss}>{textItem?.title}</h2>
      ) : null}
      {/*Preamble checks*/}
      {textItem?.preamble && !textItem?.title && textItem?.topItem ? (
        <h1 className={preambleCss}>{textItem?.preamble}</h1>
      ) : (textItem?.preamble && !textItem?.title && !textItem?.topItem) ||
        (textItem?.preamble && textItem?.title && textItem?.topItem) ? (
        <h2 className={preambleCss}>{textItem?.preamble}</h2>
      ) : textItem?.preamble && textItem?.title && !textItem?.topItem ? (
        <h3 className={preambleCss}>{textItem?.preamble}</h3>
      ) : null}
      {body && <RichText richText={body} />}
    </div>
  );
};
export default EditorialPageFullWidthTextWrapper;
